export default __webpack_public_path__ + "static/media/slide1.dbbb8a7a.jpg";